import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { ServiceResult } from '../../core/interfaces/service-result';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { PayoutFileData } from '../interfaces/payout/payout-file-data';

@Injectable({
  providedIn: 'root',
})
export class PayoutFilesService  extends BaseCrudService<PayoutFileData, PayoutFileData>{

  baseUrl = this.runtimeConfig.epaDistributionBackend;

  constructor() {
    super();
  }

  /**
   * get data with LazyLoading-Params (paging) for payout-files view
   * @param lazyLoadEvent
   * @param serviceEndpoint
   */
  findPage(lazyLoadEvent: LazyLoadEvent, serviceEndpoint: string): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(lazyLoadEvent));
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + serviceEndpoint, {headers, params});
  }

}
